var _rect, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAccessibilityIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_3388_39",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 18,
    height: 18
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_3388_39)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16 17.0001L1 2.00008L1.70711 1.29297L16.7071 16.293L16 17.0001Z",
    fill: "#656565"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.25 9.54321V6.74985C12 6.68735 12.7625 6.5936 13.5375 6.4686C14.3125 6.3436 15.05 6.18735 15.75 5.99985L15.375 4.49985C14.4 4.76235 13.3625 4.95297 12.2625 5.07172C11.1625 5.19047 10.075 5.24985 9 5.24985C8.29894 5.24985 7.59257 5.2246 6.88088 5.17409L11.25 9.54321ZM11.25 10.9574L5.31473 5.02215C4.37074 4.90257 3.47417 4.72847 2.625 4.49985L2.25 5.99985C2.95 6.18735 3.6875 6.3436 4.4625 6.4686C5.2375 6.5936 6 6.68735 6.75 6.74985V16.4998H8.25V11.9998H9.75V16.4998H11.25V10.9574ZM7.94063 4.05922C8.23438 4.35297 8.5875 4.49985 9 4.49985C9.4125 4.49985 9.76563 4.35297 10.0594 4.05922C10.3531 3.76547 10.5 3.41235 10.5 2.99985C10.5 2.58735 10.3531 2.23422 10.0594 1.94047C9.76563 1.64672 9.4125 1.49985 9 1.49985C8.5875 1.49985 8.23438 1.64672 7.94063 1.94047C7.64687 2.23422 7.5 2.58735 7.5 2.99985C7.5 3.41235 7.64687 3.76547 7.94063 4.05922Z",
    fill: "#656565"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAccessibilityIcon);
export default __webpack_public_path__ + "static/media/accessibility_icon.2ce4a2c6e6b826f6c8d6922bb4e39186.svg";
export { ForwardRef as ReactComponent };